import classNames from 'classnames';
import React, { Fragment } from 'react';
import * as Render from '../Base/Render';
import withLazyLoad from '../Containers/withLazyLoad';
import withSensitiveImage from '../Containers/withSensitiveImage';
import withSrcSets from '../Containers/withSrcSets';
import ImageBlock from '../ImageBlock';
import ResponsiveImages from './responsive-images';
import SemanticHeader from './semantic-header';
import { isMediumViewport } from '../Hooks/useMedia';

const ImageBlockLazyLoad = withLazyLoad(
  withSrcSets(withSensitiveImage(ImageBlock))
);

const View = (props) => {
  return (
    <Fragment>
      {props.Heading && (
        <SemanticHeader
          aria-hidden={isMediumViewport() && !!props?.regionalName}
          isH3={props.isH3}
          customHeadingLevel={props.headingLevel}
          className={classNames({
            'c-chapter__heading': true,
            'c-chapter__story-heading': props.StoryPageHeading,
            'c-chapter__heading--is-anchornav':
              props.AnchorSectionId &&
              !props.isH3 &&
              !props.CurrentPageProps.Content.HideAnchorNavigation &&
              !props.HideAnchorLink,
          })}
        >
          {props.Heading}
        </SemanticHeader>
      )}
      {props.RegionAddition?.ContentAbove && (
        <Render.Block
          blocks={props.RegionAddition.ContentAbove}
          propertyName="ContentAbove"
          CurrentPageProps={props.CurrentPageProps}
        >
          <Render.BlockTypeRenderer
            Blocks={props.Blocks}
            isH3={props.Heading}
            headingLevel={props.headingLevel ? props.headingLevel + 1 : 3}
            isMemberOfChapterContainer={props.isMemberOfChapterContainer}
          />
        </Render.Block>
      )}
      {props.Preamble && <p>{props.Preamble}</p>}
      {props.Image && (
        <div className={`c-chapter__img-container--${props.ImageProperties}`}>
          <Render.Block
            blocks={props.Image}
            propertyName="Image"
            CurrentPageProps={props.CurrentPageProps}
            isMemberOfChapterContainer={props.isMemberOfChapterContainer}
            isMemberOfChapter={true}
          >
            <ImageBlockLazyLoad
              Modifiers={{
                [`c-imageblock--${props.ImageProperties}`]:
                  props.ImageProperties,
              }}
              Sizes={ResponsiveImages(props)}
              {...props}
            />
          </Render.Block>
        </div>
      )}
      {props.ContentString}
      {props.RegionAddition?.ContentBelow && (
        <Render.Block
          blocks={props.RegionAddition.ContentBelow}
          propertyName="ContentBelow"
          CurrentPageProps={props.CurrentPageProps}
        >
          <Render.BlockTypeRenderer
            Blocks={props.Blocks}
            isH3={props.Heading}
            headingLevel={props.headingLevel ? props.headingLevel + 1 : 2}
            isMemberOfChapterContainer={props.isMemberOfChapterContainer}
          />
        </Render.Block>
      )}
    </Fragment>
  );
};

export default View;
